import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {FormControl,FormGroup} from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
//import { AuthService } from './auth.service';
//import { AuthGuard } from './auth.guard';
import { HttpClientModule } from  '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { ToastrModule } from 'ng6-toastr-notifications';
import { SidebarModule } from 'ng-sidebar';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { TabModule } from 'angular-tabs-component';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { UtilityService } from './utility.service';
import { AppRoutingModule }     from './app-routing.module';
import { JwtModule } from '@auth0/angular-jwt';
 import { AuthService } from './auth.service';
import { AuthGuard } from './auth.guard';
import {ErrorInterceptor} from './error.interceptor';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgDatepickerModule } from 'ng2-datepicker';
import { FileSelectDirective, FileUploadModule } from 'ng2-file-upload';
import { NgSelectModule } from '@ng-select/ng-select';
//import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
// Import angular-fusioncharts

import { FusionChartsModule } from 'angular-fusioncharts';

// Import FusionCharts library
import * as FusionCharts from 'fusioncharts';

// Load FusionCharts Individual Charts
import * as Charts from 'fusioncharts/fusioncharts.charts';
import { NgScrollbarModule } from 'ngx-scrollbar';

import { AppComponent } from './app.component';
import { CustomerComponent } from './customer/list/customer.component';
import { CustomerDetailsComponent } from './customer/detail/customer-details.component';
import { AddCustomerComponent } from './customer/add/add-customer.component';
import { PoListComponent } from './po/po-list/po-list.component';
import { PoDetailsComponent } from './po/po-details/po-details.component';
import { CreatePOComponent } from './po/create-po/create-po.component';
import { RecentPoComponent } from './po/recent-po/recent-po.component'; 
import { CreateInvoiceComponent } from './invoice/create-invoice/create-invoice.component';
import { InvoiceDetailsComponent } from './invoice/invoice-details/invoice-details.component';
import { InvoiceListComponent } from './invoice/invoice-list/invoice-list.component';
import { RecentPiComponent } from './invoice/recent-pi/recent-pi.component';
import { VendorsListComponent } from './vendor/vendors-list/vendors-list.component';
import { CreateVendorComponent } from './vendor/create-vendor/create-vendor.component';
import { VendorDetailsComponent } from './vendor/vendor-details/vendor-details.component';
import { TopVendorsComponent } from './vendor/top-vendors/top-vendors.component';
import { StateComponent } from './state/state.component';
import { CityComponent } from './city/city.component';
import { UserListComponent } from './user/user-list/user-list.component';
import { CreateUserComponent } from './user/create-user/create-user.component';
import { UserRolesComponent } from './user-roles/user-roles.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PoApproverDashboardComponent } from './po-approver/po-approver-dashboard/po-approver-dashboard.component';
import { PoApproverDetailsComponent } from './po-approver/po-approver-details/po-approver-details.component';
import { ApprovedPoComponent } from './po-approver/approved-po/approved-po.component';
import { RejectedPoComponent } from './po-approver/rejected-po/rejected-po.component';
import { FinanceTeamDashboardComponent } from './finance-team/finance-team-dashboard/finance-team-dashboard.component';
import { PaidInvoicesComponent } from './finance-team/paid-invoices/paid-invoices.component';
import { UnpaidInvoicesComponent } from './finance-team/unpaid-invoices/unpaid-invoices.component';
import { FinanceTeamPoDetailsComponent } from './finance-team/finance-team-po-details/finance-team-po-details.component';
import { LoginComponent } from './login/login.component';
import { DepartmentListComponent } from './department/department-list/department-list.component';
import { AddDepartmentComponent } from './department/add-department/add-department.component';
import { PaymenttermListComponent } from './paymentTerms/paymentterm-list/paymentterm-list.component';
import { AddPaymenttermComponent } from './paymentTerms/add-paymentterm/add-paymentterm.component';
import { QuotationListComponent } from './quotations/quotation-list/quotation-list.component';
import { AddRequirementComponent } from './quotations/add-requirement/add-requirement.component';
import { QuotationDetailsComponent } from './quotations/quotation-details/quotation-details.component';
import { BrandComponent } from './brand/brand.component';
import { CreateItemComponent } from './item/create-item/create-item.component';
import { ItemListComponent } from './item/item-list/item-list.component';
import { ItemDetailsComponent } from './item/item-details/item-details.component';
import { ItemCategoryComponent } from './item-category/item-category.component';
import { PoListPipe } from  './pipe/polist.pipe';
import { InvoiceListPipe } from  './pipe/invoicelist.pipe';
import { ItemListPipe } from  './pipe/item.pipe';
import { PoMatrixPipe } from './pipe/pomatrix.pipe';
import { QuotationListPipe } from  './pipe/quotation.pipe';
import { PotrackingListPipe } from  './pipe/potracking.pipe';
import { ItemUomComponent } from './item-uom/item-uom.component';
import { WarehouseListComponent } from './warehouse/warehouse-list/warehouse-list.component';
import { CreateWarehouseComponent } from './warehouse/create-warehouse/create-warehouse.component';
import { WarehouseDetailsComponent } from './warehouse/warehouse-details/warehouse-details.component';
import { CostcenterDetailsComponent } from './costcenter/costcenter-details/costcenter-details.component';
import { CostcenterListComponent } from './costcenter/costcenter-list/costcenter-list.component';
import { CreateCostcenterComponent } from './costcenter/create-costcenter/create-costcenter.component';
import { CreatePaymentComponent } from './payment/create-payment/create-payment.component';
import { PaymentDetailsComponent } from './payment/payment-details/payment-details.component';
import { PaymentListComponent } from './payment/payment-list/payment-list.component';
import { EntityListComponent } from './entity/entity-list/entity-list.component';
import { EntityDetailsComponent } from './entity/entity-details/entity-details.component';
import { CreateEntityComponent } from './entity/create-entity/create-entity.component';
import { ReviewListComponent } from './po-reviewer/review-list/review-list.component';
import { ReviewDetailsComponent } from './po-reviewer/review-details/review-details.component';
import { PoReviewerDashboardComponent } from './po-reviewer/po-reviewer-dashboard/po-reviewer-dashboard.component';
import { PotrackingComponent } from './po/potracking/potracking.component';
import { PendingPoComponent } from './po-approver/pending-po/pending-po.component';
// import { PomatrixComponent } from './po/Matrix-po/potracking.component'


 
// Use fcRoot function to inject FusionCharts library, and the modules you want to use

FusionChartsModule.fcRoot(FusionCharts, Charts)
export function tokenGetter() {
  return localStorage.getItem('access_token');
}

@NgModule({
  declarations: [
    AppComponent,
    CustomerComponent,
    CustomerDetailsComponent,
    AddCustomerComponent,
    PoListComponent,
    PoDetailsComponent,
    CreatePOComponent,
    CreateInvoiceComponent,
    InvoiceDetailsComponent,
    InvoiceListComponent,
    VendorsListComponent,
    CreateVendorComponent,
    VendorDetailsComponent,
    StateComponent,
    CityComponent,
    UserListComponent,
    CreateUserComponent,
    UserRolesComponent,
    DashboardComponent,
    PoApproverDashboardComponent,
    PoApproverDetailsComponent,
    ApprovedPoComponent,
    RejectedPoComponent,
    FinanceTeamDashboardComponent,
    PaidInvoicesComponent,
    UnpaidInvoicesComponent,
    FinanceTeamPoDetailsComponent,
    LoginComponent,
    RecentPoComponent,
    RecentPiComponent,
    TopVendorsComponent,
    DepartmentListComponent,
    AddDepartmentComponent,
    PaymenttermListComponent,
    AddPaymenttermComponent,
    QuotationListComponent,
    AddRequirementComponent,
    QuotationDetailsComponent,
    BrandComponent,
    CreateItemComponent,
    ItemListComponent,
    ItemDetailsComponent,
    ItemCategoryComponent,
    // PomatrixComponent,
  PoListPipe,
	InvoiceListPipe,
	ItemListPipe,
  PoMatrixPipe,
  QuotationListPipe,
  PotrackingListPipe,
	ItemUomComponent,
	WarehouseListComponent,
	CreateWarehouseComponent,
	WarehouseDetailsComponent,
	CostcenterDetailsComponent,
	CostcenterListComponent,
	CreateCostcenterComponent,
	CreatePaymentComponent,
	PaymentDetailsComponent,
	PaymentListComponent,
	EntityListComponent,
	EntityDetailsComponent,
	CreateEntityComponent,
	ReviewListComponent,
	ReviewDetailsComponent,
	PoReviewerDashboardComponent,
	PotrackingComponent,
	PendingPoComponent
	
	
  ],
  imports: [
    BrowserModule,
    NgbPaginationModule,
    BsDropdownModule.forRoot(),
    Ng4LoadingSpinnerModule,
    Ng4LoadingSpinnerModule.forRoot(),    
    FormsModule,
    ReactiveFormsModule,
    ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'}),
    BrowserAnimationsModule,    
    ToastrModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    FusionChartsModule,
    FilterPipeModule,
    TabModule,
     NgbModule,
     NgDatepickerModule,
     NgSelectModule,
     NgScrollbarModule,
	 	FileUploadModule,
  SidebarModule.forRoot(),
  //NgMultiSelectDropDownModule.forRoot(),
	JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        whitelistedDomains: ['potool.curever.com:4000'],
        blacklistedRoutes: ['potool.curever.com:4000/api/users/auth']
      }
    })
  ],
  providers: [UtilityService,AuthService,
  AuthGuard, {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }